/**
 * External dependencies
 */
import KeenSlider from "keen-slider";
import {
	ActiveClassNamePlugin,
	ArrowsPlugin,
	CreatedClassNamePlugin,
	DotsPlugin,
	ImmobileWhenAllSlidesVisible,
	ScreenReaderTextPlugin,
} from "@evermade/keen-slider-plugins";

(function () {
	let sliders = [];
	let isInitialized = false;

	window.addEventListener("DOMContentLoaded", () => {
		if (!isInitialized) {
			isInitialized = true;
			init();
		}
	});

	const init = () => {
		const els = document.querySelectorAll(".em-block-latest-stories-slider");

		// Disable/enable tab indexing for slide based on their active state (has "is-active" class)
		function toggleSlideTabIndexing(s) {
			s.slides.forEach( slide => {
				if (!slide.classList.contains("is-active")) {
					slide.querySelectorAll(".em-block-story-card__link")[0].tabIndex = -1;
					slide.querySelectorAll(".em-block-story-card__link")[0].ariaHidden = "true";
				} else {
					slide.querySelectorAll(".em-block-story-card__link")[0].removeAttribute('tabindex');
					slide.querySelectorAll(".em-block-story-card__link")[0].ariaHidden = "false";
				}
			})
		}

		els.forEach((el) => {
			const wrapper = el.querySelector(
				".em-block-latest-stories-slider__slider"
			);

			const cards = wrapper.querySelectorAll(":scope > *");
			cards.forEach((card) => wrap(card, "keen-slider__slide"));

			const controls = document.createElement("div");
			controls.classList.add("em-block-latest-stories-slider__controls");
			el.appendChild(controls);

			const plugins = [
				CreatedClassNamePlugin(),
				ActiveClassNamePlugin(),
				ImmobileWhenAllSlidesVisible(),
				ScreenReaderTextPlugin(),
			];

			const hasArrows = wrapper.classList.contains("has-arrows");
			const hasDots = wrapper.classList.contains("has-dots");

			if (hasArrows) {
				plugins.push(
					ArrowsPlugin({
						container: controls,
						className: "em-block-latest-stories-slider__arrows",
					})
				);
			}

			if (hasDots) {
				plugins.push(
					DotsPlugin({
						container: controls,
						className: "em-block-latest-stories-slider__dots",
					})
				);
			}

			const slider = new KeenSlider(
				wrapper,
				{
					slides: {
						perView: 1,
						spacing: 15,
					},
					detailsChanged(s) {
						toggleSlideTabIndexing(s)
					},
					created(s) {
						toggleSlideTabIndexing(s)
					},
					breakpoints: {
						"(min-width: 600px)": {
							slides: {
								perView: 2,
								spacing: 15,
							},
						},
						"(min-width: 960px)": {
							slides: {
								perView: 3,
								spacing: 30,
							},
						},
					},
				},
				plugins
			);

			if (!slider) {
				return false;
			}

			sliders.push(slider);
		});
	};

	const wrap = (el, className = "wrapper") => {
		const wrapper = document.createElement("div");
		wrapper.classList.add(className);
		el.parentNode.insertBefore(wrapper, el);
		wrapper.appendChild(el);
	};
})();
